<template>
    <div class="content-wrap">
        <Lnb/>
        <div :class="['flexible-content', heightMaxClass]">
            <div id="content" class="app-content" role="main">
              <Header/>
              <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
import Lnb from './Lnb';
import Header from './Header';
//import "@/assets/scss/main.scss";
export default {
  components:{
    Lnb,
    Header,
  },
  mounted(){
    
    if(this.$route.name == 'Indicator')
      this.heightMaxClass = 'height-max'
  },
  data(){
    return {
      heightMaxClass: ''
    }
  },
  
  watch: {
    $route (newVal, oldBal) {
      
      this.maxClass = '';
      if(newVal.name == 'Indicator') {
        this.heightMaxClass = 'height-max'
      }
    },
    
  },
  beforeRouteUpdate (to, from, next) {
        
  }
}
</script>

<style>

</style>